import React, { useEffect } from 'react';

// Google AdSense ad unit. Configure in .env:
//   REACT_APP_ADSENSE_CLIENT        e.g. ca-pub-1234567890123456
//   REACT_APP_ADSENSE_SLOT_DISPLAY  responsive display unit (blog list, end of article)
//   REACT_APP_ADSENSE_SLOT_ARTICLE  in-article unit (falls back to the display unit)
// Ads are used on blog pages only, never on service or sales pages.
const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOTS = {
  display: process.env.REACT_APP_ADSENSE_SLOT_DISPLAY,
  article: process.env.REACT_APP_ADSENSE_SLOT_ARTICLE || process.env.REACT_APP_ADSENSE_SLOT_DISPLAY
};

// Skip ads for automated browsers, including the pre-render step.
const isAutomated = typeof navigator !== 'undefined' && navigator.webdriver;

let scriptRequested = false;
const loadAdSenseScript = () => {
  if (scriptRequested) return;
  scriptRequested = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
};

const AdSlot = ({ type = 'display', className = '' }) => {
  const slot = SLOTS[type];
  const enabled = Boolean(CLIENT && slot && !isAutomated);

  useEffect(() => {
    if (!enabled) return;
    loadAdSenseScript();
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      // Ad blockers or a not-yet-approved account; the page works without the ad.
    }
  }, [enabled]);

  if (isAutomated) return null;

  if (!enabled) {
    if (process.env.NODE_ENV === 'development') {
      return (
        <div className={`ad-slot ad-placeholder ${className}`} aria-hidden="true">
          Ad space ({type}) &middot; shows once AdSense IDs are set in .env
        </div>
      );
    }
    return null;
  }

  const articleProps = type === 'article'
    ? { 'data-ad-format': 'fluid', 'data-ad-layout': 'in-article' }
    : { 'data-ad-format': 'auto', 'data-full-width-responsive': 'true' };

  return (
    <aside className={`ad-slot ${className}`} aria-label="Advertisement">
      <span className="ad-label">Advertisement</span>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', textAlign: type === 'article' ? 'center' : undefined }}
        data-ad-client={CLIENT}
        data-ad-slot={slot}
        {...articleProps}
      />
    </aside>
  );
};

export default AdSlot;
